// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_17jIz","itemLink":"index_itemLink_3Y6jX","itemPic":"index_itemPic_1Aj7i","itemAction":"index_itemAction_3ifch"};